import { Injectable } from '@angular/core';
import { PopoverComponent } from '../views/widgets/popover/popover.component';

@Injectable({ providedIn: 'root' })
export class PopoverService {
  private activePopover: PopoverComponent | null = null;

  register(popover: PopoverComponent): void {
    // すでに開いているポップオーバーがあれば閉じる
    if (this.activePopover && this.activePopover !== popover) {
      this.activePopover.close();
    }
    this.activePopover = popover;
  }

  unregister(popover: PopoverComponent): void {
    if (this.activePopover === popover) {
      this.activePopover = null;
    }
  }
}
